import axios from "axios";

export const getPosts = ({language, limit}) =>
  axios.get(`https://apiblog.datavisiooh.com/api/${language}/posts/${limit}`);
